// =====================================================================
// hi.js — Hindi translations.
// Mirrors the structure of en.js exactly.
// =====================================================================

export const hi = {
  code: "hi",
  label: "हिं",
  switchTo: "EN",
  switchAria: "Switch to English",

  site: {
    tagline: "स्थानीय विशेषज्ञों द्वारा रची शाही यात्राएँ।",
    description:
      "जयपुर और उसके पार प्रीमियम कैब, चुनिंदा टूर पैकेज और सहज वन-वे टैक्सी।",
    address: "जयपुर, राजस्थान, भारत",
  },

  nav: {
    home: "होम",
    cabs: "कैब सेवाएँ",
    oneway: "वन-वे",
    packages: "पैकेज",
    destinations: "कहानियाँ",
    customTrip: "कस्टम ट्रिप",
    bookOnWhatsApp: "व्हाट्सएप पर बुक करें",
    brandLine1: "जयपुर टूर्स",
    brandLine2: "एंड ट्रैवल्स",
  },

  hero: {
    badge: "जयपुर से · पूरे भारत में सेवा",
    h1Part1: "विश्वसनीय कैब और",
    h1Italic: "दर्शनीय यात्राएँ",
    h1Part2: "जयपुर में।",
    subhead:
      "चाहे आपको लोकल टैक्सी चाहिए, दिल्ली या आगरा के लिए आउटस्टेशन ड्रॉप, या पूरा राजस्थान हॉलिडे पैकेज — हम इसे आसान बनाते हैं। ईमानदार मूल्य, वेरिफाइड ड्राइवर और व्हाट्सएप पर इंस्टेंट बुकिंग।",
    ctaPrimary: "व्हाट्सएप पर बुक करें",
    ctaSecondary: "पैकेज देखें",
    ratingValue: "4.7",
    ratingTrips: "2,400+ यात्राएँ",
    verified: "वेरिफाइड ड्राइवर · GPS-ट्रैक्ड राइड",
    heroChip: "हवा महल · जयपुर",
    todaysPick: "आज की पसंद",
    pickTitle: "1-दिन जयपुर दर्शनीय यात्रा",
    pickPriceLabel: "मात्र",
    pickPriceSuffix: "· सेडान",
    seeItinerary: "यात्रा-क्रम देखें",
    waMsg: "नमस्ते Jaipur Tours & Travels, मुझे कैब/पैकेज बुक करना है। कृपया विवरण भेजें।",
  },

  cabs: {
    eyebrow: "बेड़ा · किमी आधार पर",
    title: "अपनी सवारी चुनें।",
    titleItalic: "केवल दूरी का भुगतान।",
    subtitle:
      "कॉम्पैक्ट सेडान से लेकर लग्ज़री Urbania तक — आउटस्टेशन और स्थानीय कैब। पारदर्शी प्रति-किमी मूल्य, कोई छिपा शुल्क नहीं।",
    seater: "सीटर",
    perKm: "प्रति किमी",
    enquireNow: "अभी पूछताछ करें",
    termsBadge: "ध्यान दें",
    termsTitle: "किराया नियम और शर्तें",
    termsSubtitle: "उपरोक्त सभी किमी-बेसिस बुकिंग पर लागू।",
    waMsg: (name, sub) =>
      `नमस्ते Jaipur Tours & Travels, मुझे ${name} (${sub}) किमी-बेसिस पर बुक करनी है। कृपया उपलब्धता बताएँ।`,
    fleet: [
      { id: "sedan", name: "सेडान", subtitle: "डिज़ायर / आउरा",
        features: ["AC", "म्यूज़िक सिस्टम", "2 लगेज", "पेट फ्रेंडली"] },
      { id: "ertiga", name: "अर्टिगा", subtitle: "मारुति सुज़ुकी अर्टिगा",
        features: ["AC", "विशाल जगह", "3 लगेज", "परिवार के लिए"] },
      { id: "innova", name: "इनोवा", subtitle: "टोयोटा इनोवा",
        features: ["AC", "प्रीमियम राइड", "4 लगेज", "लंबे टूर"] },
      { id: "innova-crysta", name: "इनोवा क्रिस्टा", subtitle: "टोयोटा क्रिस्टा",
        features: ["कैप्टन सीट", "प्रीमियम AC", "5 लगेज", "शानदार इंटीरियर"] },
      { id: "tempo-traveller", name: "टेम्पो ट्रैवलर", subtitle: "Force Traveller · 12 और 16 सीटर",
        features: ["AC", "रिक्लाइनर सीट", "बड़ा बूट", "ग्रुप यात्रा"] },
      { id: "urbania", name: "उर्बानिया", subtitle: "Force Urbania · 12 और 16 सीटर",
        features: ["लग्ज़री कोच", "पुश-बैक सीट", "चार्जिंग पोर्ट", "प्रीमियम"] },
    ],
    terms: [
      "प्रतिदिन न्यूनतम 250 किमी चलना अनिवार्य।",
      "रात 11 बजे के बाद ₹300 ($4) नाइट चार्ज लागू।",
      "पार्किंग, टोल टैक्स और स्टेट टैक्स शामिल नहीं।",
      "बहु-दिवसीय यात्रा पर ड्राइवर भत्ता लागू।",
    ],
  },

  oneway: {
    eyebrow: "वन-वे ड्रॉप",
    title: "एक तरफ़ का भुगतान।",
    titleItalic: "बड़ी बचत।",
    subtitle:
      "खाली रिटर्न शुल्क नहीं। वेरिफाइड ड्राइवरों के साथ कन्फ़र्म पिकअप।",
    note: "शुरुआती दरें · वाहन व तारीख़ के अनुसार बदलाव संभव",
    bookNow: "अभी बुक करें",
    startsFrom: "शुरुआत",
    km: "किमी",
    waMsg: (from, to) =>
      `नमस्ते Jaipur Tours & Travels, मुझे ${from} से ${to} तक वन-वे टैक्सी चाहिए। कृपया उपलब्धता और अंतिम मूल्य बताएँ।`,
    routes: [
      { id: "jpr-del", from: "जयपुर", to: "दिल्ली",
        highlights: ["एक्सप्रेस हाईवे", "घर से पिकअप", "24x7 उपलब्ध"] },
      { id: "jpr-agr", from: "जयपुर", to: "आगरा",
        highlights: ["ताज महल दर्शन", "फतेहपुर सीकरी विकल्प", "लचीला पिकअप"] },
      { id: "jpr-ajm", from: "जयपुर", to: "अजमेर",
        highlights: ["अजमेर शरीफ़ दरगाह", "पुष्कर एड-ऑन", "तेज़ हाईवे"] },
    ],
  },

  packages: {
    eyebrow: "चुनिंदा पैकेज",
    title: "हाथ से बुने टूर।",
    titleItalic: "स्थानीय अनुभव से तैयार।",
    subtitle:
      "नीचे का हर पैकेज असली, सड़क पर परखा हुआ यात्रा-क्रम है — कोई जेनेरिक टेम्पलेट नहीं। अपना वाहन चुनें, अपनी रफ़्तार चुनें।",
    itineraryHeader: "यात्रा-क्रम",
    foodStops: "खान-पान स्टॉप:",
    includes: "शामिल है",
    totalPackage: "कुल लागत",
    bookNow: "अभी बुक करें",
    waMsg: (title, vehicle) =>
      `नमस्ते Jaipur Tours & Travels, मुझे "${title}" पैकेज ${vehicle} में बुक करना है। कृपया विवरण और अंतिम मूल्य भेजें।`,
    list: [
      {
        id: "jpr-1day",
        title: "1-दिन जयपुर दर्शनीय यात्रा",
        duration: "1 दिन · 8–10 घंटे",
        tag: "सबसे बुक",
        summary:
          "पिंक सिटी के प्रसिद्ध क़िले, महल और खाने के अड्डों का सटीक रूप से बुना हुआ दौरा।",
        itinerary: [
          { time: "08:30", place: "आमेर क़िला", note: "शीश महल और प्राचीर" },
          { time: "10:30", place: "हाथी गाँव", note: "एलीफैंट विलेज" },
          { time: "11:30", place: "जल महल", note: "झील के बीच फोटो स्टॉप" },
          { time: "12:30", place: "रावत मिष्ठान भंडार", note: "प्याज़ कचौड़ी ब्रेक" },
          { time: "14:00", place: "सिटी पैलेस", note: "शाही प्रांगण" },
          { time: "15:30", place: "हवा महल", note: "गुलाबी जालीदार मुख" },
          { time: "17:00", place: "LMB, जौहरी बाज़ार", note: "थाली / नाश्ता" },
          { time: "18:30", place: "नाहरगढ़ क़िला", note: "जयपुर पर सूर्यास्त" },
        ],
        foodStops: ["रावत मिष्ठान भंडार", "लक्ष्मी मिष्ठान भंडार (LMB)"],
        inclusions: [
          "होटल से पिकअप व ड्रॉप",
          "प्रोफ़ेशनल ड्राइवर-गाइड",
          "ईंधन व राज्य परमिट",
          "पानी की बोतल",
        ],
        notes:
          "साफ़-सुथरी कैब और अत्यंत अनुभवी, प्रोफ़ेशनल ड्राइवर।",
        priceLabels: ["", "", "", "", ""],
      },
      {
        id: "jpr-2day",
        title: "2-दिन शाही जयपुर अनुभव",
        duration: "2 दिन · 1 रात",
        tag: "हेरिटेज पसंद",
        summary:
          "गहरा शाही अनुभव — दिन में क़िले, रात को चोखी ढाणी। पहली बार आने वालों के लिए संपूर्ण।",
        itineraryByDay: [
          {
            day: "दिन 1",
            label: "क़िले, झीलें व शहर की रोशनी",
            stops: [
              { place: "आमेर + जयगढ़", note: "शाही क़िले की यात्रा" },
              { place: "नाहरगढ़ क़िला", note: "पहाड़ी पैनोरमा" },
              { place: "हाथी गाँव व जल महल", note: "सांस्कृतिक पड़ाव" },
              { place: "वर्ल्ड ट्रेड पार्क (WTP)", note: "आधुनिक जयपुर · शॉपिंग व डिनर" },
              { place: "मोज महल", note: "शाम का विश्राम" },
            ],
          },
          {
            day: "दिन 2",
            label: "महल, मंदिर व लोक संध्या",
            stops: [
              { place: "सिटी पैलेस + जंतर मंतर", note: "UNESCO धरोहर" },
              { place: "हवा महल", note: "गुलाबी वास्तुकला" },
              { place: "बिड़ला मंदिर", note: "मोती डूंगरी पर संगमरमर मंदिर" },
              { place: "गैटोर की छत्रियाँ", note: "शाही समाधि" },
              { place: "चोखी ढाणी", note: "लोक गाँव में डिनर" },
            ],
          },
        ],
        inclusions: [
          "साफ़-सुथरी AC कैब",
          "अनुभवी, प्रोफ़ेशनल ड्राइवर",
          "घर से घर तक पिकअप",
          "अनुरोध पर कस्टम समय",
        ],
        accommodation:
          "होटल आप स्वयं चुन सकते हैं, या अनुरोध पर हम बुकिंग की व्यवस्था कर सकते हैं।",
        notes:
          "साफ़-सुथरी कैब और अत्यंत अनुभवी, प्रोफ़ेशनल ड्राइवर।",
        priceLabels: ["", "", "", "", ""],
      },
      {
        id: "pilgrim",
        title: "धार्मिक तीर्थ पैकेज",
        duration: "1–2 दिन · लचीला",
        tag: "आध्यात्मिक",
        summary:
          "शेखावाटी के सबसे प्रिय धामों का दर्शन — शांत, सहज और परिवार के अनुकूल।",
        itinerary: [
          { time: "स्टॉप 1", place: "खाटू श्याम जी", note: "प्रसिद्ध मंदिर दर्शन" },
          { time: "स्टॉप 2", place: "सालासर बालाजी", note: "हनुमान जी की कृपा" },
          { time: "स्टॉप 3", place: "रानी सती दादी, झुंझुनू", note: "ऐतिहासिक धाम" },
        ],
        inclusions: [
          "घर/होटल से पिकअप",
          "मार्ग से परिचित अनुभवी ड्राइवर",
          "लचीला दर्शन समय",
          "मल्टी-स्टॉप अनुमत",
        ],
        notes:
          "मूल्य मानक किमी-बेसिस पर वाहन अनुसार (लगभग 550 किमी राउंड-ट्रिप)।",
        priceLabels: ["", "", "", ""],
        heroImageLabels: {
          "khatu-shyam": "खाटू श्याम जी",
          "salasar": "सालासर बालाजी",
          "rani-sati": "रानी सती दादी",
        },
      },
    ],
  },

  testimonials: {
    eyebrow: "यात्रियों की ज़ुबानी",
    title: "पिंक सिटी की सड़कों",
    titleItalic: "से कहानियाँ।",
    list: [
      { id: "t1", name: "प्रिया शर्मा", location: "बेंगलुरु", trip: "1-दिन जयपुर दर्शनीय · इनोवा", rating: 5,
        quote: "हमारे ड्राइवर मनोज को हर शॉर्टकट और आमेर के बेस्ट फोटो टाइम का पता था। रावत पर प्याज़ कचौड़ी का स्टॉप एक स्वादिष्ट सरप्राइज़ था। लगा जैसे स्थानीय व्यक्ति घुमा रहा हो।" },
      { id: "t2", name: "रोहित मेहता", location: "मुंबई", trip: "2-दिन शाही जयपुर · इनोवा क्रिस्टा", rating: 5,
        quote: "एनिवर्सरी पर 2-दिन का पैकेज बुक किया। शाम को चोखी ढाणी जादुई थी। कैब बिल्कुल साफ़, ड्राइवर बेहद विनम्र। हर रुपया वसूल।" },
      { id: "t3", name: "अंजलि और परिवार", location: "दिल्ली", trip: "तीर्थ पैकेज · अर्टिगा", rating: 5,
        quote: "वृद्ध माता-पिता के साथ खाटू श्याम से सालासर एक ही ट्रिप में — लचीला समय, आरामदायक अर्टिगा, कोई जल्दबाज़ी नहीं। ड्राइवर ने धैर्य से इंतज़ार किया। दिल से अनुशंसा।" },
      { id: "t4", name: "करण सिंह", location: "गुरुग्राम", trip: "जयपुर → दिल्ली वन-वे · सेडान", rating: 5,
        quote: "रात 10 बजे वन-वे की लास्ट-मिनट बुकिंग व्हाट्सएप पर — 4 मिनट में कन्फ़र्म। ड्राइवर 6 बजे होटल पर। साफ़ डिज़ायर, स्मूद हाईवे। ऐसी ही होनी चाहिए टैक्सी बुकिंग।" },
      { id: "t5", name: "मीरा अय्यर", location: "पुणे", trip: "कस्टम 5-दिन राजस्थान · टेम्पो ट्रैवलर", rating: 5,
        quote: "हम 11 लोग, 5 शहर, बहुत सामान। JT&T के अनिल भैया ने रूट बनाया, होटल पिकअप संभाला, टेम्पो ट्रैवलर वाकई आरामदायक था। बेस्ट ट्रैवल फ़ैसला।" },
      { id: "t6", name: "विक्रम राव", location: "हैदराबाद", trip: "जयपुर → आगरा वन-वे · इनोवा", rating: 5,
        quote: "फतेहपुर सीकरी के डिटूर के साथ जयपुर-आगरा रूट लिया। ड्राइवर ने बैक रोड लीं और 45 मिनट बचाए। ईमानदार पारदर्शी रेट। फिर ज़रूर बुक करेंगे।" },
    ],
    prev: "पिछला",
    next: "अगला",
  },

  custom: {
    eyebrow: "कस्टम यात्रा",
    title: "अपनी ट्रिप नहीं दिखी?",
    titleItalic: "हम बनाएँगे।",
    body:
      "मल्टी-सिटी राजस्थान, फ़ैमिली शादी, फ़ोटोग्राफ़ी एक्सपीडिशन, तीर्थ सर्किट — सपना बताइए, हम रूट, कैब और स्टे की पेशकश करेंगे। बस एक व्हाट्सएप मैसेज दूर।",
    cta1: "व्हाट्सएप पर शुरू करें",
    cta2: "कॉल करें",
    waMsg: "नमस्ते Jaipur Tours & Travels, मुझे एक कस्टम राजस्थान ट्रिप प्लान करनी है। शुरुआती विचार: ",
    features: [
      { title: "आपके अनुरूप रूट",
        desc: "आधा-दिन, मल्टी-सिटी या 10-दिन का सर्किट — आपकी तारीख़, ऊर्जा और बजट के अनुसार।" },
      { title: "लचीला शेड्यूल",
        desc: "आमेर पर सूर्योदय? रात की चोखी ढाणी वापसी? बताइए — ड्राइवर आपकी घड़ी पर चलेंगे।" },
      { title: "स्थानीय मानवीय सपोर्ट",
        desc: "व्हाट्सएप पर असली जयपुर-स्थित व्यक्ति — कोई चैटबॉट नहीं। आम तौर पर मिनटों में जवाब।" },
    ],
  },

  footer: {
    explore: "अन्वेषण",
    contact: "संपर्क",
    crafted: "जयपुर में सावधानी से बनाया गया",
    rights: "सर्वाधिकार सुरक्षित।",
    message: "व्हाट्सएप पर मैसेज करें",
    waMsg: "नमस्ते Jaipur Tours & Travels, मुझे पूछताछ करनी है।",
  },

  widget: {
    eyebrow: "हमसे चैट करें",
    waMsg: "नमस्ते Jaipur Tours & Travels, मुझे कैब/पैकेज की पूछताछ करनी है।",
  },

  trustStats: [
    { value: "10+", label: "जयपुर की सड़कों पर वर्ष" },
    { value: "20k+", label: "खुश यात्री" },
    { value: "4.7★", label: "औसत रेटिंग" },
    { value: "24/7", label: "सपोर्ट, हर दिन" },
  ],

  blog: {
    eyebrow: "कहानियाँ व गाइड",
    title: "गंतव्य व यात्रा गाइड",
    subtitle:
      "राजस्थान से कहानियाँ, सुझाव और रोड-टेस्टेड रूट — आपकी यात्रा बेहतर बनाने के लिए।",
    readMore: "पढ़ें",
    readTime: "मिनट पठन",
    publishedOn: "प्रकाशित",
    back: "← सभी कहानियों पर वापस",
    related: "और कहानियाँ",
    notFound: "कहानी नहीं मिली।",
    notFoundCta: "सभी कहानियों पर वापस",
    waMsg: (title) =>
      `नमस्ते Jaipur Tours & Travels, मैंने आपकी गाइड "${title}" पढ़ी। मुझे ट्रिप प्लान करनी है।`,
    bookCta: "व्हाट्सएप पर ट्रिप प्लान करें",
    articles: [
      {
        slug: "best-time-to-visit-jaipur",
        title: "जयपुर घूमने का सबसे अच्छा समय: महीने-दर-महीने गाइड",
        excerpt:
          "अक्टूबर से मार्च सबसे उत्तम है — पर पिंक सिटी का हर मौसम अपना रंग रखता है। तारीख़ चुनने के लिए ईमानदार स्थानीय गाइड।",
        author: "Jaipur Tours & Travels",
        body: [
          { type: "p", text: "जयपुर हर मौसम में नया चेहरा पहनता है। जनवरी की धुंध भरे क़िलों से लेकर जून की चमकती दोपहर तक — शहर के पास हमेशा कुछ ख़ास होता है। बस सही समय चुनना है।" },
          { type: "h2", text: "सर्दी की खिड़की (अक्टूबर – मार्च)" },
          { type: "p", text: "अगर एक ही समय चुनना हो तो यही है। दिन हलके ठंडे (18–28°C), रोशनी सुनहरी और हवा महल की फ़ोटो बेहद साफ़। दीवाली से गणतंत्र दिवस तक पीक सीज़न — कैब और होटल 2 हफ़्ते पहले बुक करें।" },
          { type: "p", text: "टिप: नवंबर के पहले हफ़्ते का कोई कार्यदिवस चुनें। आमेर पर भीड़ नहीं और मौसम वैसा ही।" },
          { type: "h2", text: "शोल्डर महीने (सितंबर व अप्रैल)" },
          { type: "p", text: "अक्सर अनदेखे। सितंबर मानसून की पूँछ लाता है — अरावली हरी-भरी, भीड़ कम। अप्रैल थोड़ा गर्म (32–38°C) पर सुबह-शाम सुहावनी। 2-दिन शाही जयपुर के लिए बढ़िया वैल्यू।" },
          { type: "h2", text: "गर्मी (मई – जून)" },
          { type: "p", text: "गर्म — हम साफ़ बता रहे हैं। दोपहर 42°C+। पर इनडोर हेरिटेज (सिटी पैलेस म्यूज़ियम, अल्बर्ट हॉल) और प्रतिस्पर्धी कैब रेट के लिए अच्छा। 6 बजे शुरू करें, दोपहर आराम।" },
          { type: "h2", text: "मानसून (जुलाई – अगस्त)" },
          { type: "p", text: "सबसे रोमांटिक। नाहरगढ़ पर सूर्यास्त, अरावली पर बादल, मोरों की पुकार — जादुई। आमेर की चढ़ाई पर सड़क फिसलन भरी हो सकती है, स्थानीय अनुभवी ड्राइवर ज़रूरी।" },
          { type: "h2", text: "यात्रा प्रकार के अनुसार चयन" },
          { type: "ul", items: [
            "पहली बार पर्यटक: नवंबर या फ़रवरी",
            "फ़ोटोग्राफ़र: देर अगस्त या दिसंबर सुबह",
            "तीर्थ सर्किट (खाटू श्याम): अक्टूबर या मार्च",
            "बजट यात्री: सितंबर या अप्रैल",
          ]},
        ],
      },
      {
        slug: "khatu-shyam-darshan-guide",
        title: "खाटू श्याम जी दर्शन: पहली बार वालों के लिए सम्पूर्ण गाइड",
        excerpt:
          "समय, ड्रेस कोड, प्रसिद्ध फाल्गुन मेला, और क्यों अधिकांश तीर्थयात्री इसे सालासर बालाजी के साथ जोड़ते हैं।",
        author: "Jaipur Tours & Travels",
        body: [
          { type: "p", text: "खाटू श्याम जी राजस्थान के सबसे अधिक देखे गए धामों में से एक है — और सबसे श्रद्धालु। यदि आप पहली बार दर्शन की योजना बना रहे हैं, तो यह गाइड हमारी सैकड़ों यात्राओं पर आधारित है।" },
          { type: "h2", text: "स्थान व दूरी" },
          { type: "p", text: "खाटू सीकर ज़िले में है, जयपुर से NH-52 के रास्ते ~80 किमी उत्तर में। सामान्य ट्रैफ़िक में सेडान से लगभग 1.5 घंटे। अधिकांश तीर्थयात्री इसे सालासर बालाजी (और 90 किमी) व झुंझुनू के रानी सती दादी के साथ जोड़ते हैं।" },
          { type: "h2", text: "दर्शन का सबसे अच्छा समय" },
          { type: "p", text: "सुबह दर्शन (4:30 AM – 12:30 PM) सबसे शांत। रविवार से बचें — 2 घंटे की लाइन। एकादशी और फाल्गुन मेले पर लाखों भक्त; पहले या बाद में जाएँ।" },
          { type: "h2", text: "ड्रेस कोड व शिष्टाचार" },
          { type: "p", text: "साधारण, आरामदायक सूती सबसे अच्छा। कंधे और घुटने ढके हों। मोबाइल, चमड़ा और बाहर के फूल अंदर वर्जित — लॉकर (निःशुल्क) में रखें या ड्राइवर के पास।" },
          { type: "h2", text: "फाल्गुन मेला (फ़रवरी – मार्च)" },
          { type: "p", text: "वार्षिक मेला अद्भुत पर भीड़भाड़ — 10 दिन में 10+ लाख दर्शनार्थी। रींगस/सीकर में आवास 4–6 हफ़्ते पहले बुक करें। सुबह 5 बजे से रोड बंदी सामान्य — अनुभवी स्थानीय ड्राइवर अमूल्य।" },
          { type: "h2", text: "सालासर बालाजी के साथ कैसे जोड़ें" },
          { type: "p", text: "हमारा तीर्थ पैकेज जयपुर से खाटू → सालासर → रानी सती दादी ~550 किमी राउंड-ट्रिप कवर करता है। एक लंबे दिन में या सालासर में रात्रि विश्राम के साथ दो दिन में।" },
          { type: "h2", text: "प्रो टिप्स" },
          { type: "ul", items: [
            "चढ़ावा और पार्किंग के लिए छोटे नोट रखें",
            "दर्शन के बाद खाटू की 'जलेबी' दुकानों पर ज़रूर रुकें",
            "केवल बाहरी प्रांगण में फ़ोटो अनुमत",
            "रिटर्न कैब पहले बुक करें — पीक टाइम पर ऑटो 3 गुना",
          ]},
        ],
      },
      {
        slug: "jaipur-to-agra-road-trip",
        title: "जयपुर से आगरा रोड ट्रिप: रूट, स्टॉप और ईमानदार समय",
        excerpt:
          "240 किमी, दो एक्सप्रेसवे, और बीच में एक छुपा मुग़ल नगर। पिंक सिटी से ताज तक की यात्रा को ट्रांसफ़र नहीं, छुट्टी बनाने वाली पूरी गाइड।",
        author: "Jaipur Tours & Travels",
        body: [
          { type: "p", text: "जयपुर–आगरा ड्राइव भारत के सबसे बार ली जाने वाली हेरिटेज रूट में से एक है। दो विश्व-धरोहर शहर, 240 किमी, और सही योजना के साथ — अपने आप में यादगार रोड ट्रिप।" },
          { type: "h2", text: "दो रूट, एक चुनाव" },
          { type: "p", text: "रूट A (तेज़): NH-21 + यमुना एक्सप्रेसवे, भरतपुर के रास्ते — 4 घंटे 30 मिनट, साफ़ सड़क, कम सीनिक स्टॉप। रूट B (हेरिटेज): फतेहपुर सीकरी के रास्ते — 45 मिनट अधिक, पर UNESCO का भूतिया नगर मिलेगा। समय हो तो B सुझाते हैं।" },
          { type: "h2", text: "रास्ते के सबसे अच्छे स्टॉप" },
          { type: "p", text: "भरतपुर पक्षी विहार (केवलादेव) — प्रकृति प्रेमियों के लिए 90-मिनट का बढ़िया डिटूर, ख़ासकर नवंबर–फ़रवरी। फतेहपुर सीकरी का बुलंद दरवाज़ा सुनहरे घंटे में बेजोड़। मेहताब बाग़ साइड पर हल्के ढाबे का पराठा बेस्ट।" },
          { type: "h2", text: "जयपुर से कब निकलें" },
          { type: "p", text: "सुबह 6:30 बजे निकलें। 10:30 तक फतेहपुर सीकरी, 12 तक पूरा, दोपहर ताज दर्शन के लिए आगरा (शुक्रवार को ताज बंद — कोई और दिन)।" },
          { type: "h2", text: "वाहन सुझाव" },
          { type: "p", text: "2 वयस्क + हल्का सामान: सेडान (डिज़ायर) ₹11/किमी ($0.13/km) सबसे किफ़ायती। 4 वयस्क/सीनियर: इनोवा ₹16/किमी ($0.19/km) — कैप्टन सीट हाईवे को आरामदायक बनाती हैं। 8 से कम पैसेंजर के लिए टेम्पो ट्रैवलर न लें; इनोवा बेहतर।" },
          { type: "h2", text: "टोल व अन्य शुल्क" },
          { type: "ul", items: [
            "टोल (राउंड ट्रिप): ~₹950 ($12)",
            "फतेहपुर सीकरी पार्किंग व प्रवेश: ~₹100 ($1.50)",
            "रात्रि ड्राइवर भत्ता: ₹400 ($5)",
            "स्टेट परमिट (यदि लागू): ~₹200 ($2.50)",
          ]},
          { type: "h2", text: "वन-वे बनाम राउंड ट्रिप" },
          { type: "p", text: "केवल आगरा जाना है तो वन-वे टैक्सी (₹3,000 / $36 से, सेडान) खाली रिटर्न से बचाती है। उसी दिन वापसी के लिए 90 मिनट के ताज समय वाला राउंड ट्रिप सबसे लोकप्रिय — हमने सैकड़ों चलाई हैं।" },
        ],
      },
    ],
  },
};
